import { render, staticRenderFns } from "./FeedbackStatusDialog.vue?vue&type=template&id=133e0d33&scoped=true"
import script from "./FeedbackStatusDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackStatusDialog.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackStatusDialog.vue?vue&type=style&index=0&id=133e0d33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e0d33",
  null
  
)

export default component.exports